import { createAction, props } from '@ngrx/store';
import { Changelog } from './changelogs.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records changelogs',
    props<{ version: string }>()
    
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records changelogs success', 
    props<{ listData: Changelog[] }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records changelogs failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record changelogs',
    props<{version: string, id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record changelogs success', 
    props<{ singleData: Changelog }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record changelogs failure', 
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state faq',
);